import axios from "axios";
import { toast } from "react-toastify";

import { SETTINGS_CONFIG } from "../../appConstants";

export const fetchSettingConfigs = async () => {
  const config = {
    method: "get",
    url: `${SETTINGS_CONFIG}`,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    toast.error(`Error: ${error.message}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};

export const postSettingConfigs = async (params) => {

  const data = params;

  const config = {
    method: "put",
    url: `${SETTINGS_CONFIG}`,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    if (response.data.success === true) {
      toast.success(`Success: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      toast.error(`Error: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    return response.data;
  } catch (error) {
    toast.error(`Error: ${error.message}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};
